import { Component } from "@angular/core";

import { environment } from "../../../../environments/environment";
import { EnvironmentType } from "../../../core/models/environment-type.enum";

@Component({
  selector: "app-environment-indicator",
  standalone: true,
  imports: [],
  template: `
    <div [class]="'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border transition-colors ' + getEnvironmentBgColor()">
      <span class="w-1.5 h-1.5 rounded-full bg-current opacity-60 mr-2"></span>
      {{ getEnvironmentName() }}
    </div>
  `,
})
export class EnvironmentIndicatorComponent {
  getEnvironmentName(): string {
    return environment.name;
  }

  getEnvironmentBgColor(): string {
    switch (environment.env) {
      case EnvironmentType.PROD:
        return 'bg-blue-100 dark:bg-blue-900/30 text-blue-800 dark:text-blue-300 border border-blue-200 dark:border-blue-800';
      case EnvironmentType.STG:
        return 'bg-orange-100 dark:bg-orange-900/30 text-orange-800 dark:text-orange-300 border border-orange-200 dark:border-orange-800';
      case EnvironmentType.DEV:
        return 'bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-300 border border-green-200 dark:border-green-800';
      case EnvironmentType.LOCAL:
        return 'bg-pink-100 dark:bg-pink-900/30 text-pink-800 dark:text-pink-300 border border-pink-200 dark:border-pink-800';
      default:
        return 'bg-light-surface-variant dark:bg-dark-surface-variant text-light-text dark:text-dark-text';
    }
  }
}
